import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const reviewApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createReview: builder.mutation({
      query: (review) => ({
        url: API_PREFIX + "/review/create",
        method: "POST",
        body: review,
      }),
    }),
    getReviewByPropertyUUID: builder.query({
      query: ({ property_uuid, page }) => ({
        url: API_PREFIX + `/review/property/${property_uuid}/${page}`,
      }),
    }),
    getReviewsByHostUUID: builder.query({
      query: ({ host_uuid, page }) => ({
        url: API_PREFIX + `/review/host/${host_uuid}/${page}`,
      }),
    }),
  }),
});

export const {
  useCreateReviewMutation,
  useGetReviewByPropertyUUIDQuery,
  useLazyGetReviewByPropertyUUIDQuery,
  useGetReviewsByHostUUIDQuery,
  useLazyGetReviewsByHostUUIDQuery,
} = reviewApiSlice;
